import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=c3f47b62&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"
import style0 from "../../theme/code-block.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./CodeBlock.vue?vue&type=style&index=1&id=c3f47b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f47b62",
  null
  
)

export default component.exports